"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RiskLevel = function (props) {
    var classes = ['RiskLevel'];
    var level = props.risklevel;
    if (level !== null && level !== undefined && level >= props.required_risklevel) {
        classes.push(props.class + (props.opportunity ? "opp" : ""));
    }
    return React.createElement("div", { className: classes.join(" ") });
};
var RiskLevelIndicator = function (props) {
    var risklevel = [];
    risklevel.push(React.createElement(RiskLevel, { risklevel: props.risklevel.level, required_risklevel: 0, opportunity: props.risklevel.opportunity, class: "RiskLevel--low" }));
    risklevel.push(React.createElement(RiskLevel, { risklevel: props.risklevel.level, required_risklevel: 10, opportunity: props.risklevel.opportunity, class: "RiskLevel--mid" }));
    if (props.risklevel.critical) {
        risklevel.push(React.createElement(RiskLevel, { risklevel: props.risklevel.level, required_risklevel: 20, opportunity: props.risklevel.opportunity, class: "RiskLevel--critical" }));
    }
    risklevel.push(React.createElement(RiskLevel, { risklevel: props.risklevel.level, required_risklevel: 30, opportunity: props.risklevel.opportunity, class: "RiskLevel--high" }));
    return (React.createElement("div", { className: "RiskLevelIndicator" }, risklevel));
};
exports.default = RiskLevelIndicator;
